<template>
    <el-dialog title="Filters"
               width="1000px"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <el-tabs type="card">
            <el-tab-pane label="Employer">
                <filter-text id="employer_id" name="Employer ID" type="number" :data="filter"></filter-text>
                <filter-text id="employer" name="Employer contains" type="text" :data="filter"></filter-text>
                <filter-select id="agency" name="Agency" :dropdown="dropdowns.agency" :data="filter"></filter-select>
                <filter-text id="contact_person" name="Contact person name or email" type="text" :data="filter"></filter-text>
                <filter-select id="pricelist" name="Pricing" :dropdown="dropdowns.pricelist" :data="filter"></filter-select>
                <filter-boolean id="has_3rd_party_lp_jobs" name="Employer has 3rd party LP jobs" :data="filter"></filter-boolean>
                <filter-text id="campaign" name="Campaign contains" type="text" :data="filter"></filter-text>
                <filter-select id="account_manager" name="Account Manager" :dropdown="dropdowns.account_manager" :data="filter"></filter-select>
                <filter-select id="salesman" name="Sales Rep" :dropdown="dropdowns.sales_rep" :data="filter"></filter-select>
                <filter-select id="overbudget" name="Campaigns Fulfillment" :dropdown="dropdowns.overbudget" :data="filter"></filter-select>
            </el-tab-pane>

            <el-tab-pane label="Billing Setup">
                <filter-number-between id="billable" name="Billable between" :data="filter"></filter-number-between>
                <filter-number-between id="budget" name="Budget between" :data="filter"></filter-number-between>
                <filter-number-between id="net_invoice" name="NET Invoice between" :data="filter"></filter-number-between>
                <filter-select id="billing_type" name="Subscription Type" :dropdown="dropdowns.billing_type" :data="filter"></filter-select>
                <filter-select id="billing_status" name="Status" :dropdown="dropdowns.status" :data="filter"></filter-select>
                <filter-text id="io_number" name="IO Number" type="number" :data="filter"></filter-text>
                <filter-select id="billing_method" name="Billing Method" :dropdown="dropdowns.billing_method" :data="filter"></filter-select>
                <filter-select id="billing_timeframe" name="Billing Timeframe" :dropdown="dropdowns.billing_timeframe" :data="filter"></filter-select>
            </el-tab-pane>

            <el-tab-pane label="Billing Term">
                <filter-select id="term_ends" name="Billing Term ends by" :dropdown="dropdowns.term_ends" :data="filter"></filter-select>
                <filter-date-between id="term_from" name="Billing Term From" :data="filter"></filter-date-between>
                <filter-date-between id="term_to" name="Billing Term To" :data="filter"></filter-date-between>
                <filter-number-between id="term_autorenewal_months" name="Billing Term (months)" :data="filter"></filter-number-between>
            </el-tab-pane>
        </el-tabs>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save">Filter</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: [
            'show',
            'dropdowns',
            'filter'
        ],
        data() {
            return {
            };
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                this.$emit('filter');
                this.showForm = false;
            }
        }
    }
</script>

<style>
    .filter-entry {
        margin-top: 20px;
        display: flex;
        align-items: center;
    }
    .filter-text {
        width: 300px;
        margin: 0 15px;
    }
    .filter-number {
        width: 160px;
        margin: 0 15px;
    }
    .filter-select {
        width: 500px;
        margin: 0 15px;
    }

    .filter-label {
        width: 250px;
        text-align: right;
    }
</style>
